export default __webpack_public_path__ + "static/4-b4076f57d3d3bea8a34e3ae2dd7a3ba0.jpeg";